import { navigate } from '@reach/router';
import AuthError from '~lib/authError';

export default handleErr => err => {
  if (err instanceof AuthError) {
    navigate('/logout');
  } else if (handleErr instanceof Function) handleErr(err);
};
